import React, { useState, useEffect } from 'react';
import './style.css';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Options, Select } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Title } from '../../components/Title';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import { Col, Row, Button } from 'react-bootstrap';
import Pen from '../../img/icon/Caneta.svg';
import AlertMessage from '../../components/Alert';
import { PgrRevisao } from './Revisao';
import { useLocation, useParams } from 'react-router-dom';
import { Autocomplete, Box, TextField, Tooltip } from '@mui/material';
import { Modal as MaterialModal } from '@mui/material';
import { NiveisAcesso } from '../../constants/niveisAcesso';
import { CookieBanner } from '../../components/CookieBanner';
import useDriver from '../../hooks/useDriver';
import { Trash } from 'react-bootstrap-icons';

export function MeuPGR() {
  const { empresaId, fdtId } = useParams<{ empresaId: string, fdtId: string }>();

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
  const [nivelAcesso, setNivelAcesso]: any = useState("");
  const [companies, setCompanies]: any = useState([]);
  const [fdts, setFdts]: any = useState([]);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [isInsertionMode, setIsInsertionMode] = useState(false);
  const [selectedFdtId, setSelectedFdtId]: any = useState(null);
  const [selectedRiskLevel, setSelectedRiskLevel] = useState('');
  const [selectedRiskLevelId, setSelectedRiskLevelId] = useState('');
  const [newFdtName, setNewFdtName] = useState('');
  const [externoPgr, setExternoPgr] = useState(0);
  const [externoPcmso, setExternoPcmso] = useState(0);
  const [newFdtRiskLevel, setNewFdtRiskLevel] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAutoInsertionMode, setIsAutoInsertionMode] = useState(false);
  const [titlePath, setTitlePath] = useState('');
  const location = useLocation();
  const pathName = location.pathname;
  const routeName = pathName.substring(pathName.lastIndexOf('/') + 1);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [quarentenaGrauRisco, setQuarentenaGrauRisco]: any = useState('');
  const [fdtsQuarentena, setFdtsQuarentena]: any = useState([]);
  const [username, setUsername] = useState('');
  const { pgrExterno } = useDriver(location.pathname);
  const [inputValue, setInputValue] = useState<string>('');
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [showDeleteFdtModal, setShowDeleteFdtModal] = useState(false)

  // Load companies initially
  useEffect(() => {
    api.get(`nivel-acesso`).then((response: any) => {
      setNivelAcesso(response.data.nivel);
    })

    loadCompanies();
    nivelAcessoUsuario();
  }, [empresaId, fdtId]);

  useEffect(() => {
    if (selectedRiskLevelId) {
      api.get(`get-quarentena/pgr_fdt/grau_risco/${selectedRiskLevelId}`).then((response: any) => {
        setQuarentenaGrauRisco(response.data[0])
      })
    }
  }, [selectedRiskLevelId, selectedRiskLevel]);

  useEffect(() => {
    const fectData = async () => {
      await api.get(`get-quarentena-fdts`).then((response: any) => {
        setFdtsQuarentena(response.data)
      });
      const user = await api.get('dados-usuario');
      setUsername(user.data.nome);
    }
    fectData();
  }, []);

  useEffect(() => {
    loadFdts();
  }, [selectedCompany]);

  useEffect(() => {
    setFilteredCompanies(companies);
  }, [companies]);

  // Function to load companies
  const loadCompanies = async () => {
    try {
      const response = await api.get('empresas');
      setCompanies(response.data.message ? [] : response.data);
      const searchParams = new URLSearchParams(location.search);
      const empresaId = searchParams.get('empresa');
      if (empresaId) {
        setSelectedCompany(empresaId);
        const empresaEncontrada = companies.find((company: any) => company.id === empresaId);
        if (empresaEncontrada) {
          setInputValue(`${empresaEncontrada.nome} - ${empresaEncontrada.cnpj}`);
        }
      } else {
        setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
        if (response.data.length > 0) {
          const empresaSelecionada = response.data[0].id;
          const empresaEncontrada = companies.find((company: any) => company.id === empresaSelecionada);
          if (empresaEncontrada) {
            setInputValue(`${empresaEncontrada.nome} - ${empresaEncontrada.cnpj}`);
          }
        }
      };
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchFunctionQuantity = async () => {
    const productResponse = await api.get(`listar-produto-user/${selectedCompany}/${selectedFdtId}`);
    const productData = productResponse.data;

    const hasValidProduct = productData.length > 0 && productData[0].id_produto && productData[0].id_produto !== 0;
    return hasValidProduct;
  };

  useEffect(() => {
    // Define o título baseado na URL atual
    const path = window.location.pathname; // Obtém o caminho da URL

    if (path.includes("/pgr")) {
      setTitlePath('PGR'); // Define o título para PGR
    } else if (path.includes("/pcmso")) {
      setTitlePath('PCMSO'); // Define o título para PCMSO
    }

  }, [window.location.pathname]); // Dependência para re-executar o useEffect quando a URL mudar


  // Function to load FDTs
  const loadFdts = async () => {
    if (selectedCompany) {
      try {
        setIsLoading(true)
        const response = await api.post(`listar-pgr`, { id_empresa: selectedCompany });
        const fdtsFromApi = response.data.fdts || [];
        setFdts(fdtsFromApi);

        const isAutoInsertion = fdtsFromApi.length === 0;
        setIsInsertionMode(isAutoInsertion);
        setIsAutoInsertionMode(isAutoInsertion); // Define se o modo de inserção é automático

        const searchParams = new URLSearchParams(location.search);
        const idFdt = searchParams.get('fdt');
        if (idFdt && idFdt !== '0') {
          setSelectedFdtId(Number.parseInt(idFdt))
        } else {
          if (fdtsFromApi.length > 0) {
            if (fdtId) { setSelectedFdtId(fdtId) } else {
              setSelectedFdtId(fdtsFromApi[0].id);

            }
            setSelectedRiskLevel(fdtsFromApi[0].grau_risco);
          } else {
            setSelectedFdtId(null);
            setSelectedRiskLevel('');
          }
        };
      } catch (error) {
        console.error("Error fetching fdts:", error);
      } finally {
        setIsLoading(false)
      }
    }
  };

  useEffect(() => {
    if (nivelAcesso == NiveisAcesso.ADMIN) {
      setExternoPgr(0);
      setExternoPcmso(0);
    }
  }, [nivelAcesso]);

  // Function to load FDTs
  const nivelAcessoUsuario = async () => {
    try {
      const response: any = await api.get(`nivel-acesso`);
      setNivelAcesso(response.data.nivel);

    } catch (error) {
      console.error("Error fetching fdts:", error);
    }
  };

  const tratarOpcaoDoAutocomplete = (newValue: any) => {
    if (newValue.length === 1 || typeof newValue === 'number') {
      setSelectedCompany(newValue);

      const empresaEncontrada = companies.find((company: { id: number; }) => company.id === parseInt(newValue));

      if (empresaEncontrada) {
        setInputValue(`${empresaEncontrada.nome} - ${formatCNPJ(empresaEncontrada.cnpj)}`);
      }
    } else if (newValue && typeof newValue === 'object') {
      setSelectedCompany(newValue.id);
      setInputValue(`${newValue.nome} - ${formatCNPJ(newValue.cnpj)}`);
    }
  };

  const formatCNPJ = (cnpj: any) => {
    const cleanCNPJ = cnpj.replace(/[\.\-\/\s]/g, '').toUpperCase();

    if (cleanCNPJ.length !== 14) {
      return cnpj;
    }

    return `${cleanCNPJ.substring(0,2)}.${cleanCNPJ.substring(2,5)}.${cleanCNPJ.substring(5,8)}/${cleanCNPJ.substring(8,12)}-${cleanCNPJ.substring(12,14)}`;
  };


  const tratarLabelExibicaoAutocomplete = (option: any) => {
    if (!option) return '';

    if (typeof option !== 'object') {
      const empresaEncontrada = companies.find((company: any) => company.id == option);
      if (empresaEncontrada) {
        return `${empresaEncontrada.nome} - ${formatCNPJ(empresaEncontrada.cnpj)}`;
      }
    } else if (typeof option === 'object' && option.nome && option.cnpj) {
      return `${option.nome} - ${formatCNPJ(option.cnpj)}`;
    }

    return '';
  };

  const handleAutocompleteOnChange = (newValue: any) => {
    if (newValue) {
      if (selectedCompany && selectedCompany === newValue.id) {
        setSelectedCompany(null);

        setTimeout(() => {
          tratarOpcaoDoAutocomplete(newValue);

          setSelectedRiskLevel('');
          setSelectedFdtId(null);
          setIsEditMode(false);
          setNewFdtName('');
          setNewFdtRiskLevel('');
        }, 0);
      } else {
        tratarOpcaoDoAutocomplete(newValue);
        setSelectedCompany(newValue.id);

        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('empresa');
        searchParams.delete('fdt')
        searchParams.delete('revisao')
        window.history.replaceState({}, '', `${location.pathname}`);

        setSelectedRiskLevel('');
        setSelectedFdtId(null);
        setIsEditMode(false);
        setNewFdtName('');
        setNewFdtRiskLevel('');
      }
    } else if (nivelAcesso === 4) {
      setInputValue('');
      setSelectedCompany(null);
    }
  };


  const handleFdtNameChange = (e: any) => {
    setNewFdtName(e.target.value.toUpperCase());
  };


  const handleSelectFdt = (fdt: any) => {
    if (nivelAcesso !== NiveisAcesso.ADMIN) {
      setExternoPgr(fdt.externo_pgr);
      setExternoPcmso(fdt.externo_pcmso);
    } else {
      setExternoPgr(0);
      setExternoPcmso(0);
    }

    setSelectedFdtId(fdt.id);
    setSelectedRiskLevel(fdt ? fdt.grau_risco : '');
    setSelectedRiskLevelId(fdt ? fdt.id : '')

    if (!isInsertionMode && !isEditMode) {
      setNewFdtName(fdt ? fdt.nome : '');
    }
  };


  const enterInsertionMode = () => {
    setIsInsertionMode(true);
    setIsEditMode(false);
    setNewFdtName('');
    setNewFdtRiskLevel('');
  };


  const exitInsertionMode = () => {
    setIsInsertionMode(false);
  };
  const validRiskLevels = ["1", "2", "3", "4"];

  const handleRiskLevelChange = (e: any) => {
    let value = parseInt(e.target.value);

    if (value < 1) value = 1;
    else if (value > 4) value = 4;

    const valueStr = value.toString();
    if (isEditMode) {
      setSelectedRiskLevel(valueStr);
    } else {
      setSelectedRiskLevel(valueStr);
    }
  };

  const insertFdt = async () => {
    const newFdtData = {
      id_empresa: selectedCompany,
      nome: newFdtName,
      grau_risco: selectedRiskLevel
    };

    try {
      const response = await api.post('inserir-fdt', newFdtData);
      const insertedFdtId = response.data.id;

      await api.post('inserir-revisao', {
        id_empresa: selectedCompany,
        id_fdt: insertedFdtId,
        tipo_documento: routeName
      });

      await loadFdts();
      setSelectedFdtId(insertedFdtId);
      exitInsertionMode();

      setAlert({ message: 'FDT e revisão inseridas com sucesso!', variant: 'success', show: true });

    } catch (error) {
      console.error("Erro ao inserir FDT ou revisão:", error);
      setAlert({ message: 'Erro ao inserir FDT ou revisão', variant: 'danger', show: true });
    }
  };

  const enterEditMode = () => {
    setIsInsertionMode(false);
    setIsEditMode(true);

    const fdtToEdit = fdts.find((f: any) => f.id === selectedFdtId);
    if (fdtToEdit) {
      setNewFdtName(fdtToEdit.nome);
      setSelectedRiskLevel(fdtToEdit.grau_risco);
    }
  };

  const exitEditMode = () => {
    setIsEditMode(false);
  };

  const saveEdits = async () => {
    const updatedFdtData = {
      id_empresa: selectedCompany,
      id_fdt: selectedFdtId,
      nome: newFdtName,
      grau_risco: selectedRiskLevel
    };

    try {
      await api.post('editar-fdt', updatedFdtData);
      await loadFdts();
      setSelectedFdtId(selectedFdtId);
      exitEditMode();
      setAlert({ message: 'FDT atualizada com sucesso!', variant: 'success', show: true });
    } catch (error) {
      setAlert({ message: 'Falha ao editar FDT!', variant: 'danger', show: true });
      console.error("Error updating FDT:", error);
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      setIsLoading(true)
      if (await handleSearchFunctionQuantity()) {
        setShowDeleteFdtModal(true)
        setAlert({ message: 'Já existe um plano adquirido para essa frente de trabalho!', variant: 'danger', show: true });
        return
      }
      await api.post('excluir-fdt', { id: selectedFdtId, id_empresa: selectedCompany });
      setAlert({ message: 'FDT excluída com sucesso!', variant: 'success', show: true });

      await loadFdts();

    } catch (error) {
      console.error("Error deleting FDT:", error);
      setAlert({ message: 'Falha ao excluir FDT!', variant: 'danger', show: true });
    }
    finally {
      setIsLoading(false)
      setIsEditMode(false);
    }

  };

  const handleCloseHelpModal = () => {
    setShowHelpModal(false);
  };
  let log
  let tooltipTitle
  if (quarentenaGrauRisco) {
    log = JSON.parse(quarentenaGrauRisco.log);
    if (log.valor_original) {
      tooltipTitle = `Valor original: ${log.valor_original}, Valor atual: ${log.valor_atual}`;
    } else {
      tooltipTitle = `Nova frente de trabalho`;
    }

  }

  const handleSelectQuarentenaFdt = () => {
    const quarentenaFdt = fdts.find((fdt: any) =>
      fdtsQuarentena.some((q: any) => q.id_registro == fdt.id && q.novo == '1')
    );
    if (quarentenaFdt) {
      setSelectedFdtId(quarentenaFdt.id);
    }
  };

  const removeCNPJMask = (cnpj: string) => cnpj.replace(/[\.\-\/\s]/g, '');

  const filterOptions = (options: any, inputValue: string) => {
    if (!inputValue) return options;
    if (inputValue.length < 2) return options;
    const inputLimpo = removeCNPJMask(inputValue).toUpperCase();
    const apenasNumeros = /^\d+$/.test(inputLimpo);
    return options.filter((option: any) => {
      if (apenasNumeros || /^[A-Z0-9]+$/.test(inputLimpo)) {
        return removeCNPJMask(option.cnpj).toUpperCase().includes(inputLimpo);
      } else {
        return option.nome.toLowerCase().includes(inputValue.toLowerCase());
      }
    });
  };

  const handleAutocompleteOnInputChange = (inputValue: any, reason: any) => {
    if (reason === 'clear') {
      handleAutocompleteOnChange(null);
    } else {
      setInputValue(inputValue);
    }
  };

  return (
    <div>
      <Load isLoading={isLoading} />
      <Sidebar />
      <Header route='./' />
      {nivelAcesso != "4" && !isLoading && companies.length === 0 ? (
        <Main>
          <CardContent>
            <Text text="Você precisa registrar uma empresa para gerenciar o PGR" />
          </CardContent>
        </Main>
      ) : (
        <Main>
          <Title text={titlePath} />
          <div>
            <CardContent>
              {/* Company Selection */}
              <div className='d-flex align-items-center' style={{ width: '100%' }}>
                <Text text="Empresa" />
                {/* <Select width="600px" id='empresas' onSelect={handleAutocompleteOnChange}>
                  {companies.map((company: any, index: any) => (
                    <Options key={company.id} value={company.id} name={company.nome} selected={selectedCompanyId ? selectedCompanyId == company.id : index === 0} />
                  ))}
                </Select> */}
                <Autocomplete
                  options={companies}
                  filterOptions={(options, { inputValue }) => filterOptions(options, inputValue)}
                  getOptionLabel={(option: any) => tratarLabelExibicaoAutocomplete(option)}
                  value={selectedCompany}
                  inputValue={inputValue}
                  onChange={(_, newValue) => handleAutocompleteOnChange(newValue)}
                  renderInput={(params) => (<TextField {...params} label="Digite nome ou CNPJ e selecione" />)}
                  style={{ width: '400px' }}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  noOptionsText="Digite nome ou CNPJ e selecione"
                  onInputChange={(_, inputValue, reason) => handleAutocompleteOnInputChange(inputValue, reason)}
                />
              </div>
            </CardContent>
          </div>

          {/* FDT Management */}
          <div id={!pgrExterno ? "pgrStep2" : "pgrStep1"}>
            <CardContent>
              <Row>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%'
                }}>
                  <Title text="Frente de trabalho" />
                  <Button
                    style={{
                      width: '40px',
                      borderRadius: '20px',
                    }}
                    onClick={() => setShowHelpModal(true)}>
                    ?
                  </Button>
                </Box>
                <p style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '0.2%' }}>Ajuda</p>
              </Row>
              {!isInsertionMode && !isEditMode ? (
                <Row>
                  {/* Existing FDT Selection */}
                  <Col xs={12} md={4} xl={2}>
                    <FormGroup>
                      <Label title="GRAU DE RISCO" htmlFor="gr" />
                      {nivelAcesso == 4 ? (
                        <>
                          <Tooltip title={tooltipTitle} placement="top">
                            <input className={quarentenaGrauRisco?.analise == 1 ? `quarentena-error` : ''} type="text" id="gr" placeholder="2" value={selectedRiskLevel} style={{ width: '100%' }} disabled />
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          <input type="text" id="gr" placeholder="2" value={selectedRiskLevel} style={{ width: '100%' }} disabled />
                        </>
                      )}

                    </FormGroup>
                  </Col>
                  <Col xs={12} md={8} xl={5}>
                    {fdts.length > 0 && (
                      <div>
                        {nivelAcesso == NiveisAcesso.ADMIN && fdts.some((fdt: any) => fdtsQuarentena.some((q: any) => q.id_registro == fdt.id && q.novo == '1')) ? (
                          <>
                            <span className="pulsing-text" onClick={handleSelectQuarentenaFdt}>Frente de trabalho adicionada manualmente!</span>
                          </>

                        ) : (
                          <Label title="FRENTE DE TRABALHO (FDT)" htmlFor="fdt" />
                        )}
                      </div>
                    )}
                    <Select
                      width="100%"
                      className={quarentenaGrauRisco?.novo == 1 && nivelAcesso == NiveisAcesso.ADMIN ? `quarentena-error` : ''}
                      id="fdts"
                      onSelect={(selectedId: any) => {
                        const selectedFdt = fdts.find((fdt: any) => fdt.id === selectedId);
                        if (selectedFdt) {
                          handleSelectFdt(selectedFdt);
                        }
                      }}
                      value={selectedFdtId}
                    >
                      {fdts.map((fdt: any) => (
                        <Options key={fdt.id} value={fdt.id} name={fdt.nome} selected={selectedFdtId === fdt.id} />
                      ))}
                    </Select>
                  </Col>
                  {(titlePath == 'PGR' || titlePath == 'pgr' || nivelAcesso == NiveisAcesso.ADMIN) ? (

                    <Col xs={12} xl={5}>
                      &nbsp;
                      <div className="d-grid d-sm-flex justify-content-lg-end justify-content-md-start crud-fdt">

                        <Button className='btn-main' onClick={enterInsertionMode}>Nova FDT</Button>
                        {!externoPgr && !externoPcmso && (
                          <>
                            <Button variant='primary' onClick={enterEditMode}>Editar FDT
                              <img src={Pen} />
                            </Button>
                            {nivelAcesso == NiveisAcesso.ADMIN && (
                              <Button variant='danger' onClick={handleDeleteConfirm}>
                                <Trash />
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    </Col>
                  ) : (
                    <Col xs={12} xl={5}>
                      &nbsp;
                      {/* <div className="d-grid d-sm-flex justify-content-lg-end justify-content-md-start crud-fdt">
                      <Button className='btn-main' onClick={enterInsertionMode}>Nova FDT</Button>
                      <Button variant='primary' onClick={enterEditMode}>Editar FDT
                        <img src={Pen} />
                      </Button>
                    </div> */}
                    </Col>
                  )}
                </Row>
              ) : (
                <Row>
                  {/* Insertion Mode */}
                  <Col xs={12} md={4} xl={2}>
                    <FormGroup>
                      <Label title={isEditMode ? "EDITAR GRAU DE RISCO" : "INSERIR GRAU DE RISCO"} htmlFor="gr" />
                      <input
                        type="number"
                        id="gr"
                        min="1"
                        max="4"
                        value={selectedRiskLevel}
                        onChange={handleRiskLevelChange}
                        style={{ width: '100%' }}
                      />

                    </FormGroup>
                  </Col>
                  <Col xs={12} md={8} xl={5}>
                    <FormGroup>
                      <Label title={isEditMode ? "EDITAR FRENTE DE TRABALHO (FDT)" : "INSERIR FRENTE DE TRABALHO (FDT)"} htmlFor="newFdt" />
                      <input
                        style={{ width: '100%' }}
                        id="newFdt"
                        placeholder="Insira uma nova FDT"
                        value={newFdtName}
                        onChange={handleFdtNameChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={5} className="d-flex justify-content-end align-items-end gap-2">
                    <div className='nameInput'>
                      &nbsp;
                      {isEditMode ? (
                        <Button className='btn-main' onClick={saveEdits}>Salvar</Button>
                      ) : (
                        <Button className='btn-main' onClick={insertFdt}>Inserir</Button>
                      )}
                    </div>
                    <div >
                      &nbsp;
                      {isEditMode || (isInsertionMode && !isAutoInsertionMode) && (
                        <Button variant='secondary' onClick={isEditMode ? exitEditMode : exitInsertionMode}>Cancelar</Button>
                      )}
                      {isEditMode && (
                        <Button variant='secondary' onClick={isEditMode ? exitEditMode : exitInsertionMode}>Cancelar</Button>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
            </CardContent>
          </div>
          {!isAutoInsertionMode && selectedFdtId ? (
            <PgrRevisao idFdt={selectedFdtId} idEmpresa={selectedCompany} documento={titlePath} externoPgr={externoPgr} externoPcmso={externoPcmso} />
          ) : (
            <div></div>
          )}
          <AlertMessage
            show={alert.show}
            message={alert.message}
            variant={alert.variant}
            onClose={() => setAlert({ ...alert, show: false })}
          />
          <MaterialModal
            open={showHelpModal}
            onClose={handleCloseHelpModal}
            style={{ backdropFilter: 'blur(10px)' }}
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              display: 'block',
              flexDirection: 'column',
              alignItems: 'center',
              width: '700px',
              maxWidth: '90%',
              maxHeight: '80%'
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                <h4>AJUDA</h4>
                <p>
                  <b>Frente de Trabalho (FDT):</b>
                </p>
                <p>
                  <b>FDT:</b> A frente de trabalho é uma área ou equipe designada para executar tarefas específicas dentro de um projeto.

                </p>
                <p>
                  <b>Grau de Risco:</b> O grau de risco do (FDT) é uma medida usada para avaliar os níveis de exposição a riscos ocupacionais durante as atividades de trabalho.

                </p>
              </Box>
            </Box>
          </MaterialModal>
          <CookieBanner />
        </Main>

      )}
    </div>
  );
}
